import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'
import _imports_1 from '../components/bg-handover-sti-now.svg'
import _imports_2 from '../components/bg-handover-sti-late.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-ae0c4764")

_pushScopeId("data-v-ae0c4764")
const _hoisted_1 = {
  id: "tab-list-booking",
  class: "bg-gray-lp-1000 px-3 py-2.5 h-full flex flex-col gap-y-3"
}
const _hoisted_2 = { class: "bg-white rounded-lg flex flex-col gap-y-1 pt-2" }
const _hoisted_3 = { class: "flex items-center gap-x-4 justify-between px-2" }
const _hoisted_4 = { class: "text-sm text-black-lp-300 font-semibold" }
const _hoisted_5 = { class: "flex justify-end items-center " }
const _hoisted_6 = { class: "text-14px font-normal text-gray-500" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0
}, null, -1)
const _hoisted_8 = { class: "flex items-center justify-between px-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "w-full h-full object-fill",
  src: _imports_1
}, null, -1)
const _hoisted_10 = { class: "flex items-center justify-between w-full absolute inset-0 px-5 text-white" }
const _hoisted_11 = { class: "flex items-center gap-x-2" }
const _hoisted_12 = { class: "text-base font-semibold leading-5" }
const _hoisted_13 = {
  key: 1,
  class: "flex items-end"
}
const _hoisted_14 = { class: "font-bold text-5xl" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-2xl font-bold" }, " STT ", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "w-full h-full object-fill",
  src: _imports_2
}, null, -1)
const _hoisted_17 = { class: "flex items-center justify-between w-full absolute inset-0 px-5 text-white" }
const _hoisted_18 = { class: "flex items-center gap-x-2 text-white" }
const _hoisted_19 = { class: "text-base font-semibold leading-5" }
const _hoisted_20 = {
  key: 1,
  class: "flex items-end"
}
const _hoisted_21 = { class: "font-bold text-5xl" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-2xl font-bold" }, " STT ", -1)
const _hoisted_23 = { class: "bg-white flex flex-col text-xs overflow-hidden h-screen relative w-full px-3 py-2 rounded-lg" }
const _hoisted_24 = { class: "flex items-center justify-between gap-x-4" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "flex items-center space-x-2" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "px-1 rounded-full bg-red-lp-3100 text-red-lp-2400 font-medium text-10px" }, " New ", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "px-1 rounded-full bg-red-lp-3100 text-red-lp-2400 font-medium text-10px" }, " New ", -1)
const _hoisted_29 = {
  key: 4,
  class: "flex items-center space-x-2"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "px-1 rounded-full bg-red-lp-3100 text-red-lp-2400 font-medium text-10px" }, " New ", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "px-1 rounded-full bg-red-lp-3100 text-red-lp-2400 font-medium text-10px" }, " New ", -1)
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 4 }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_35 = { class: "overflow-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_PickupBookingSummary = _resolveComponent("PickupBookingSummary")!
  const _component_Search = _resolveComponent("Search")!
  const _component_AdvancedFilter = _resolveComponent("AdvancedFilter")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalErrorBalance = _resolveComponent("ModalErrorBalance")!
  const _component_DetailRejectPopup = _resolveComponent("DetailRejectPopup")!
  const _component_ModalInstantBoookingConfirmation = _resolveComponent("ModalInstantBoookingConfirmation")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_ModalRequestPickup = _resolveComponent("ModalRequestPickup")!
  const _component_ModalActivePickupWarning = _resolveComponent("ModalActivePickupWarning")!
  const _component_ModalPickupRequestSuccess = _resolveComponent("ModalPickupRequestSuccess")!
  const _component_SavedAddressList = _resolveComponent("SavedAddressList")!
  const _component_ModalAddNewAddress = _resolveComponent("ModalAddNewAddress")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("bookingShipment.list.handoverSummary")), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("bookingShipment.list.dataUpdatedEvery10Min")), 1),
            _hoisted_7,
            _createVNode("div", {
              class: "text-14px font-normal text-red-500 ml-1 cursor-pointer underline",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRefreshSTISummary && _ctx.onRefreshSTISummary(...args)))
            }, _toDisplayString(_ctx.$t("bookingShipment.list.refresh")), 1)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", {
            class: "relative flex items-center justify-center w-full cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoNeedToStiPage(true, false)))
          }, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _withDirectives(_createVNode("div", _hoisted_12, null, 512), [
                  [_directive_sanitize_html, _ctx.$t('bookingShipment.list.handoverStiNow')]
                ]),
                _createVNode(_component_Icons, {
                  name: "chevron-right",
                  class: "w-3"
                })
              ]),
              (_ctx.isLoadingSTTSummary)
                ? (_openBlock(), _createBlock(_component_skeleton, {
                    key: 0,
                    width: "250px",
                    height: "62px"
                  }))
                : (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.formatPriceWithoutCurrency(
                    _ctx.STISTTDueSummaryData.totalNow,
                    _ctx.accountCurrency
                  )), 1),
                    _hoisted_15
                  ]))
            ])
          ]),
          _createVNode("div", {
            class: "relative flex items-center justify-center w-full cursor-pointer",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotoNeedToStiPage(false, true)))
          }, [
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("bookingShipment.list.handoverStiLate")), 1),
                _createVNode(_component_Icons, {
                  name: "chevron-right",
                  class: "w-3"
                })
              ]),
              (_ctx.isLoadingSTTSummary)
                ? (_openBlock(), _createBlock(_component_skeleton, {
                    key: 0,
                    width: "250px",
                    height: "62px"
                  }))
                : (_openBlock(), _createBlock("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, _toDisplayString(_ctx.formatPriceWithoutCurrency(
                    _ctx.STISTTDueSummaryData.totalOverdue,
                    _ctx.accountCurrency
                  )), 1),
                    _hoisted_22
                  ]))
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.isAccountPOS]
      ]),
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_PickupBookingSummary, {
            key: 0,
            summaryData: _ctx.pickupCorporateSummary,
            onRequestPickup: _ctx.onRequestPickup,
            onLihatStt: _ctx.onViewStt,
            onUbahAlamat: _ctx.onOpenSavedAddressList,
            onTambahAlamat: _ctx.showModalAddAddress,
            onBuatPickupManual: _ctx.onOpenModalRequestPickupManual,
            onLihatPickupAktif: _ctx.onViewPickup,
            showChangeAddress: true,
            fromListBooking: ""
          }, null, 8, ["summaryData", "onRequestPickup", "onLihatStt", "onUbahAlamat", "onTambahAlamat", "onBuatPickupManual", "onLihatPickupAktif"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_23, [
        _withDirectives(_createVNode("div", {
          class: "fixed right-0 h-full z-20",
          style: 
          `background-color:rgba(0,0,0,0.3); top: 9rem; width: calc(100% - ${
            _ctx.isAdvancedFilterOpened && _ctx.isCollapseSidebar ? `4px` : `24px`
          });`
        
        }, null, 4), [
          [_vShow, _ctx.isAdvancedFilterOpened]
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: _ctx.$t('bookingV3.list.searchStt'),
              class: "w-300px"
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
            _withDirectives(_createVNode(_component_AdvancedFilter, {
              ref: "advancedFilterListBookingV2",
              "model-value": _ctx.advancedFilterData,
              onChangeFilter: _ctx.onChangeAdvancedFilter,
              onResetFilter: _cache[4] || (_cache[4] = (flag) => _ctx.onResetAdvancedFilter(false, flag)),
              customSenderPhone: _ctx.getPhoneNumber
            }, null, 8, ["model-value", "onChangeFilter", "customSenderPhone"]), [
              [_vShow, _ctx.isAbleToAdvanceFilter]
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            (_ctx.isCreateButtonV4LionPro)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 0,
                  onClick: _ctx.handleButtonBookingV4,
                  title: "Create Booking",
                  textColor: "white",
                  disabled: !_ctx.validationAccount
                }, {
                  suffix: _withId(() => [
                    _hoisted_27
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]))
              : (_ctx.isBookingRetailV4)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 1,
                    title: "Booking Retail",
                    textColor: "white",
                    onClick: _ctx.onBookingRetailV4,
                    disabled: !_ctx.validationAccount
                  }, {
                    suffix: _withId(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
                : _createCommentVNode("", true),
            (_ctx.isCreateButtonV3LionPro)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 2,
                  onClick: _ctx.handleButtonBookingV3,
                  title: _ctx.$t('bookingShipment.list.createBooking'),
                  textColor: "white",
                  disabled: !_ctx.validationAccount
                }, null, 8, ["onClick", "title", "disabled"]))
              : (_ctx.isBookingRetail)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 3,
                    title: _ctx.$t('bookingShipment.list.bookingRetail'),
                    textColor: "white",
                    onClick: _ctx.onBookingRetail,
                    disabled: !_ctx.validationAccount
                  }, null, 8, ["title", "onClick", "disabled"]))
                : _createCommentVNode("", true),
            (_ctx.createBookingClientAccount)
              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                  (_ctx.isCreateButtonV4Client)
                    ? (_openBlock(), _createBlock(_component_LpButton, {
                        key: 0,
                        onClick: _ctx.handleButtonBookingClientV4,
                        title: _ctx.$t('bookingShipment.list.bookingClient'),
                        textColor: "white",
                        disabled: !_ctx.validationAccount
                      }, {
                        suffix: _withId(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }, 8, ["onClick", "title", "disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_LpButton, {
                    onClick: _ctx.handleButtonBookingClientV3,
                    title: _ctx.$t('bookingShipment.list.bookingClient'),
                    textColor: "white",
                    disabled: !_ctx.validationAccount
                  }, null, 8, ["onClick", "title", "disabled"])
                ]))
              : (_ctx.permissionBookingOtherList.total)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 5,
                    onClick: _cache[5] || (_cache[5] = 
              (event) => {
                _ctx.hitGtmBookingClicked();
                _ctx.openBookingOthers(event);
              }
            ),
                    title: _ctx.$t('bookingShipment.list.others'),
                    color: "red-lp-100",
                    textColor: "red-lp-100",
                    outline: "",
                    iconV2: "",
                    icon: _ctx.isOpenBookingOthers ? 'chevron-up' : 'chevron-down',
                    iconColor: "red-lp-100",
                    disabled: !_ctx.validationAccount
                  }, null, 8, ["title", "icon", "disabled"]))
                : _createCommentVNode("", true),
            _createVNode(_component_OverlayPanel, {
              ref: "opBookingOthers",
              appendTo: "body",
              style: {"width":"auto"}
            }, {
              default: _withId(() => [
                (_ctx.isBookingClientV4)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      onClick: _ctx.handleButtonBookingClientV4,
                      class: "w-72",
                      flat: "",
                      dense: "",
                      iconV2: "",
                      iconLeft: "booking-client-v2",
                      sizeIcon: "w-10",
                      title: _ctx.$t('bookingShipment.list.bookingClient')
                    }, {
                      suffix: _withId(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }, 8, ["onClick", "title"]))
                  : _createCommentVNode("", true),
                (_ctx.isBookingClient)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 1,
                      onClick: _ctx.handleButtonBookingClientV3,
                      class: "w-72",
                      flat: "",
                      dense: "",
                      iconV2: "",
                      iconLeft: "booking-client-v2",
                      sizeIcon: "w-10",
                      title: _ctx.$t('bookingShipment.list.bookingClient')
                    }, null, 8, ["onClick", "title"]))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateShipmentId)
                  ? (_openBlock(), _createBlock("hr", _hoisted_32))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateShipmentId)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 3,
                      onClick: _cache[6] || (_cache[6] = 
                (event) => {
                  _ctx.goToCreateShipmentBook();
                  _ctx.openBookingOthers(event);
                }
              ),
                      class: "w-72",
                      flat: "",
                      dense: "",
                      customClass: "text-left",
                      iconV2: "",
                      iconLeft: "booking-shipment-v2",
                      sizeIcon: "w-10",
                      title: _ctx.$t('bookingShipment.list.bookingAppMarketplace')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateInstantBooking)
                  ? (_openBlock(), _createBlock("hr", _hoisted_33))
                  : _createCommentVNode("", true),
                (_ctx.isAbleToCreateInstantBooking)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 5,
                      onClick: _cache[7] || (_cache[7] = 
                (event) => {
                  _ctx.tncModal = true;
                  _ctx.openBookingOthers(event);
                }
              ),
                      class: "w-72",
                      flat: "",
                      dense: "",
                      iconV2: "",
                      iconLeft: "booking-instant-v2",
                      sizeIcon: "w-10",
                      title: _ctx.$t('bookingShipment.list.bookingInstant')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512)
          ])
        ]),
        _hoisted_34,
        _createVNode("div", _hoisted_35, [
          _createVNode(_component_TableV2, {
            columns: _ctx.columns,
            data: _ctx.shipmentBooking,
            isEmpty: _ctx.isErrorList,
            emptyHeaderMessage: 
            _ctx.isEmpty
              ? _ctx.$t('bookingShipment.list.emptyHeaderMessage')
              : _ctx.$t('bookingShipment.list.emptyHeaderMessageFiltered')
          ,
            emptyMessage: 
            _ctx.isEmpty
              ? _ctx.$t('bookingShipment.list.emptyMessage')
              : _ctx.$t('bookingShipment.list.emptyMessageFiltered')
          ,
            loading: _ctx.isLoading,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[8] || (_cache[8] = ($event: any) => (_ctx.pagination = $event)),
            onRequest: _ctx.onRequest,
            isSpaceTop: false,
            borderTop: false,
            isDetailAble: false,
            isRightFreeze: "",
            totalColumnFreeze: 2,
            totalPercentFreeze: 25,
            bgHeader: "bg-white",
            isBorderOnHeadBgWhite: "",
            "delete-tooltip": _ctx.$t('bookingShipment.action.cancelBooking'),
            onDeleteItem: _ctx.onOpenPopupCancelBooking,
            isPinnedScrollBottom: "",
            pinnedSubstractHeight: _ctx.isAccountPOS ? '400px' : '300px',
            paginationStyle: _ctx.paginationStyle,
            customClassPagination: "absolute w-full bottom-0 pr-6"
          }, null, 8, ["columns", "data", "isEmpty", "emptyHeaderMessage", "emptyMessage", "loading", "pagination", "onRequest", "delete-tooltip", "onDeleteItem", "pinnedSubstractHeight", "paginationStyle"])
        ])
      ])
    ]),
    (_ctx.balanceUnderLimit)
      ? (_openBlock(), _createBlock(_component_ModalErrorBalance, {
          key: 0,
          modelValue: _ctx.balanceUnderLimit,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.balanceUnderLimit = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.isRejectPopup)
      ? (_openBlock(), _createBlock(_component_DetailRejectPopup, {
          key: 1,
          "is-detail": true,
          isShow: _ctx.isRejectPopup,
          "onUpdate:isShow": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isRejectPopup = $event)),
          sttNumber: _ctx.sttNumberSelected,
          onSuccess: _ctx.onRequest
        }, null, 8, ["isShow", "sttNumber", "onSuccess"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalInstantBoookingConfirmation, {
      isOpen: _ctx.tncModal,
      onClose: _ctx.onCloseTncModal,
      onAction: _ctx.goToInstantBooking
    }, null, 8, ["isOpen", "onClose", "onAction"]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.notification = $event)),
      isCustom: "",
      message: _ctx.copyStyles.message,
      customStyles: _ctx.copyStyles,
      isAutoDisplay: false,
      isAutoClose: "",
      timeout: 3,
      class: _ctx.copyStyles.width,
      showIconClose: false
    }, null, 8, ["modelValue", "message", "customStyles", "class"]),
    _withDirectives(_createVNode(_component_ModalRequestPickup, {
      "is-shown": _ctx.openModalRequestPickup,
      mode: _ctx.requestPickupMode,
      prefill: _ctx.requestPickupPrefill,
      onClose: () => (_ctx.openModalRequestPickup = false),
      onRefreshSummary: _ctx.fetchSummaryListPickupV2,
      onSuccess: _ctx.onRequestPickupSuccess
    }, null, 8, ["is-shown", "mode", "prefill", "onClose", "onRefreshSummary", "onSuccess"]), [
      [_vShow, _ctx.openModalRequestPickup]
    ]),
    _createVNode(_component_ModalActivePickupWarning, {
      isOpen: _ctx.isActivePickupWarningOpen,
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isActivePickupWarningOpen = false)),
      onConfirm: _ctx.onOpenModalRequestPickup
    }, null, 8, ["isOpen", "onConfirm"]),
    _createVNode(_component_ModalPickupRequestSuccess, {
      visible: _ctx.openModalPickupRequestSuccess,
      "order-id": _ctx.pickupSuccess.orderId,
      "total-koli": _ctx.pickupSuccess.totalKoli,
      "total-weight-kg": _ctx.pickupSuccess.totalWeightKg,
      "pickup-date": _ctx.pickupSuccess.pickupDate,
      "pickup-time-start": _ctx.pickupSuccess.pickupTimeStart,
      "label-url": _ctx.pickupSuccess.labelUrl,
      onClose: _ctx.onCloseModalPickupRequestSuccess
    }, null, 8, ["visible", "order-id", "total-koli", "total-weight-kg", "pickup-date", "pickup-time-start", "label-url", "onClose"]),
    _withDirectives(_createVNode(_component_SavedAddressList, {
      selectedAddress: _ctx.selectedAddress,
      "onUpdate:isShown": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isChangeAddressOpen = false)),
      onSelectAddress: _ctx.onSelectAddress,
      onDefaultAddressChanged: _ctx.onDefaultAddressChanged,
      onAddressFormSuccess: _ctx.onAddressFormSuccess,
      onAddressDeleted: _ctx.onAddressDeleted
    }, null, 8, ["selectedAddress", "onSelectAddress", "onDefaultAddressChanged", "onAddressFormSuccess", "onAddressDeleted"]), [
      [_vShow, _ctx.isChangeAddressOpen]
    ]),
    _withDirectives(_createVNode(_component_ModalAddNewAddress, {
      formType: "add",
      isVisible: _ctx.isAddAddress,
      onClose: _ctx.closeModalAddAddress,
      forceDefault: true,
      onOnSuccess: _ctx.onAddressFormSuccess
    }, null, 8, ["isVisible", "onClose", "onOnSuccess"]), [
      [_vShow, _ctx.isAddAddress]
    ])
  ], 64))
})